import { defineCustomElement } from "ionicons/components/ion-icon.js";
import { h, defineComponent } from "vue";
import { getConfig } from "../utils";
export const IonIcon = /*@__PURE__*/ defineComponent({
    name: "IonIcon",
    props: {
        color: String,
        flipRtl: Boolean,
        icon: String,
        ios: String,
        lazy: String,
        md: String,
        mode: String,
        name: String,
        size: String,
        src: String,
    },
    setup(props, { slots }) {
        defineCustomElement();
        return () => {
            var _a, _b;
            const { icon, ios, md, mode } = props;
            let iconToUse;
            const config = getConfig();
            const iconMode = mode || (config === null || config === void 0 ? void 0 : config.get("mode"));
            if (ios || md) {
                if (iconMode === "ios") {
                    iconToUse = (_a = ios !== null && ios !== void 0 ? ios : md) !== null && _a !== void 0 ? _a : icon;
                }
                else {
                    iconToUse = (_b = md !== null && md !== void 0 ? md : ios) !== null && _b !== void 0 ? _b : icon;
                }
            }
            else {
                iconToUse = icon;
            }
            return h("ion-icon", Object.assign(Object.assign({}, props), { icon: iconToUse }), slots);
        };
    },
});
//# sourceMappingURL=IonIcon.js.map